import gql from 'gql-tag'
import { BASE_CONDITION_FRAGMENT } from 'fragments/condition.query'
import { BASE_CONSENT_FRAGMENT } from 'fragments/consent.query'
import { BASE_COVERAGE_FRAGMENT } from 'fragments/coverage.query'
import { BASE_DEVICE_FRAGMENT } from 'fragments/device.query'
import { BASE_ORGANIZATION_FRAGMENT } from 'fragments/organization.query'
import { BASE_PATIENT_FRAGMENT } from 'fragments/patient.query'
import { BASE_PRACTITIONER_FRAGMENT } from 'fragments/practitioner.query'
import { ConsentTypeCode } from 'fhir/Consent/constants'

export const PATIENT_GENERAL_PRACTITIONER_FRAGMENT = gql`
  fragment UsePatientChart_GeneralPractitioner on Patient {
    generalPractitioner {
      resource {
        ...BaseOrganization
        ...BasePractitioner
      }
    }
  }
`

export const PATIENT_CHART_CONSENT_PERFORMER_ORGANIZATION_FRAGMENT = gql`
  fragment UsePatientChart_ConsentWithPerformerOrganization on Consent {
    performer {
      resource {
        ...BaseOrganization
      }
    }
  }
`

export const PATIENT_CHART_CONSENT_ACTOR_PROVISION_FRAGMENT = gql`
  fragment UsePatientChart_ConsentWithActor on Consent {
    provision {
      actor {
        role {
          coding {
            system
            code
          }
        }
        reference {
          resource {
            ...BasePractitioner
            ...BaseOrganization
            ...BasePatient
          }
        }
      }
    }
  }
`

export const PATIENT_CHART_CONSENT_FRAGMENT = gql`
  fragment UsePatientChart_Consent on Consent {
    ...BaseConsent
    ...UsePatientChart_ConsentWithPerformerOrganization
    ...UsePatientChart_ConsentWithActor
  }
`

export const GET_PATIENT_CHART = gql`
  query UsePatientChart($patientId: ID!) {
    Patient(id: $patientId) {
      ...BasePatient
      ...UsePatientChart_GeneralPractitioner
      ConditionList(_reference: patient) {
        ...BaseCondition
      }
      DeviceList(_reference: patient) {
        ...BaseDevice
      }
      CoverageList(_reference: patient) {
        ...BaseCoverage
      }
      ConsentList(_reference: patient, category: "${ConsentTypeCode.AUTHORIZATION}") {
        ...UsePatientChart_Consent
      }
    }
  }
  ${BASE_PATIENT_FRAGMENT}
  ${BASE_PRACTITIONER_FRAGMENT}
  ${BASE_ORGANIZATION_FRAGMENT}
  ${PATIENT_GENERAL_PRACTITIONER_FRAGMENT}
  ${BASE_CONDITION_FRAGMENT}
  ${BASE_DEVICE_FRAGMENT}
  ${BASE_COVERAGE_FRAGMENT}
  ${BASE_CONSENT_FRAGMENT}
  ${PATIENT_CHART_CONSENT_FRAGMENT}
  ${PATIENT_CHART_CONSENT_ACTOR_PROVISION_FRAGMENT}
  ${PATIENT_CHART_CONSENT_PERFORMER_ORGANIZATION_FRAGMENT}
`
